// extracted by mini-css-extract-plugin
module.exports = {"row":"catalog_item_box-module__row___10X6z","saleProductAvailability":"catalog_item_box-module__saleProductAvailability___1fntR"};